package models

import androidx.compose.foundation.lazy.LazyListItemInfo
import androidx.compose.runtime.Stable

@Stable
data class ScrollSnapshot(
    val index: Int = 0,
    val offset: Int = 0,
    val viewportHeightPx: Int = 0,
    val visibleItems: List<LazyListItemInfo> = listOf()
)
